import { alertConstants } from '../_constants';

export function alert(state = { toasts: [] }, action) {
    switch (action.type) {
        case alertConstants.SUCCESS:
            return { ...state, toasts: [...state.toasts, { type: 'alert-success', message: action.message }] };
        case alertConstants.ERROR:
            return { ...state, toasts: [...state.toasts, { type: 'alert-danger', message: action.message }] };
        case alertConstants.CLEAR:
            return { toasts: [] }; // Reset to initial state shape
        default:
            return state;
    }
}